export default "__VITE_ASSET__12d09ec3__$_?component__"